export default __webpack_public_path__ + "static/media/Oceanland_Whitepaper_v0822.5f27bf80.pdf";